import React from 'react';
import { Redirect, Route, Switch } from "react-router-dom";

import NotFoundPage from '../pages/not-found';
import DashboardPage from '../pages/dashboard/dashboard';

import CreateHomePage from '../pages/create/create-home';
import CreateWallPage from '../pages/create/create-wall';
import CreateBirthdayPage from '../pages/create/create-birthday';

import LoginPage from '../pages/login';
import GreetingPage from '../pages/greeting/greeting';
import { useUser } from '../contexts/user';
import PrivateRoute from './private-route';
import { Loading } from 'aws-amplify-react';
import  ScrollToTop  from '../utils/scroll-to-top';

export default () => {
   const { user } = useUser();

   const DashBoardPageOrPostLoginPage = () => {
      const postLoginURL = localStorage.getItem('postLoginURL');
      if (postLoginURL) {
         localStorage.removeItem('postLoginURL');
         return <Redirect to={postLoginURL} />
      }
      return <DashboardPage />
   }

   return (
      <>
      <ScrollToTop />
      <Switch>
         <Route exact path="/">
            {user ? user.isLoading
               ? <Loading />
               : <DashBoardPageOrPostLoginPage /> : <LoginPage />}
         </Route>

         <Route exact path="/login">
            {user ? user.isLoading
               ? <Loading />
               : <Redirect to="/" /> : <LoginPage />
            }
         </Route>

         <Route exact path="/create" component={CreateHomePage} />
         <Route exact path="/create/birthday" component={CreateBirthdayPage} />

         <PrivateRoute exact path="/create/:occasion/:layout" component={CreateWallPage} />
         <PrivateRoute exact path="/greeting/:wallId" component={GreetingPage} />

         <Route component={NotFoundPage} />
      </Switch>
      </>
   )

}